const isPlainObject = (value: unknown): value is Record<string, unknown> => {
  if (!value || typeof value !== 'object') return false;
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
};

const withSortedKeys = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(withSortedKeys);
  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.keys(value)
        .sort()
        .map((key) => [key, withSortedKeys(value[key])])
    );
  }
  return value;
};

/** Whether two JSON values hold the same data, whatever order their objects' keys come in. */
export const sameJson = (first: unknown, second: unknown): boolean =>
  JSON.stringify(withSortedKeys(first)) === JSON.stringify(withSortedKeys(second));
